import { deepmerge } from '@fastify/deepmerge';

// it seems that deepmerge is not typed properly
type deepMergeType = (options: { cloneProtoObject: typeof cloneByReference }) => <T>(a: Partial<T>, b: Partial<T>) => T;

const cloneByReference = (v: unknown) => v;

export const deepmergeByReference = (deepmerge as deepMergeType)({
  cloneProtoObject: cloneByReference,
});
